import {isUndefined} from 'lodash';

import {SkeletonLoader} from '~/shared/components/Loaders';
import {getLocalizationService} from '~/shared/services/localisationService';
import {Payment} from '~/shared/store/models';
import {Root, TableMobileWrapper} from '~/shared/components/UserTransactions/components/styled';
import {Title, TotalRow} from '~/shared/components/UserTransactions/shared';

import MobileTotalRow from './MobileTotalRow';
import MobileLoaderComponent from './MobileLoaderComponent';
import CompanyAnnouncement from './CompanyAnnouncement';

type MobileTotalsTableProps = {
  dateBias: number;
  companyAnnouncement?: string;
  paymentsWithSummaryRow: MobilePayment[];
  isIntelReport: boolean;
  isKlaReport: boolean;
  checkIfMoneycardIsCredit: (value: number) => boolean;
  className?: string;
};

interface MobilePayment extends Payment {
  total: number;
  marked: boolean;
  cardSuffix: string;
}

const MobileTotalsTable = ({
  dateBias,
  companyAnnouncement,
  paymentsWithSummaryRow,
  isIntelReport,
  isKlaReport,
  checkIfMoneycardIsCredit,
  className,
}: MobileTotalsTableProps) => {
  const {t} = getLocalizationService();
  return (
    // @ts-expect-error styled needs to be rewritten with ts
    <Root spaceTop={dateBias !== 0} mobile className={className}>
      {/* @ts-expect-error ../../../shared needs to be rewritten with ts */}
      <Title isMobile>{t('total_payments_by_payment_type')}</Title>
      <SkeletonLoader shouldShowLoader={isUndefined(paymentsWithSummaryRow)} LoaderComponent={MobileLoaderComponent}>
        {companyAnnouncement && <CompanyAnnouncement companyAnnouncement={companyAnnouncement} />}
        <TableMobileWrapper>
          {paymentsWithSummaryRow?.map(payment => {
            const {marked, cardSuffix, paymentMethod, total, paymentId} = payment;
            const isTenbisCredit = Boolean(paymentId && checkIfMoneycardIsCredit(paymentId));
            if (!marked) {
              return (
                <MobileTotalRow
                  key={`${cardSuffix}_${paymentMethod}`}
                  paymentMethodLabel={isTenbisCredit ? t('tenbis_credit') : t(paymentMethod.toLowerCase())}
                  isIntelReport={isIntelReport}
                  isKlaReport={isKlaReport}
                  {...payment}
                />
              );
            }
            // @ts-expect-error TotalRow needs to be rewritten with ts
            return <TotalRow key="total" label={t('total_charges')} price={total} />;
          })}
        </TableMobileWrapper>
      </SkeletonLoader>
    </Root>
  );
};

export default MobileTotalsTable;
